import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
    { q: t('faq.q6'), a: t('faq.a6'), bullets: [t('faq.a6_b1'), t('faq.a6_b2'), t('faq.a6_b3'), t('faq.a6_b4')], bulletOutro: t('faq.a6_outro') },
    { q: t('faq.q7'), a: t('faq.a7') },
    { q: t('faq.q8'), a: t('faq.a8') },
    { q: t('faq.q9'), a: t('faq.a9') },
  ];

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-16 lg:py-24 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg-2)' }}
    >
      <div className="max-w-[1160px] mx-auto">
        <h2
          className="font-bold tracking-tight text-2xl sm:text-3xl lg:text-[34px] text-center mb-12"
          style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
        >
          {t('faq.title')}
        </h2>

        <div data-testid="faq-accordion" className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              data-testid={`faq-item-${i}`}
              className="rounded-[20px] overflow-hidden transition-colors duration-200"
              style={{
                backgroundColor: openIndex === i ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.03)',
                border: `1px solid ${openIndex === i ? 'rgba(214,168,74,0.25)' : 'rgba(255,255,255,0.08)'}`,
                borderLeft: openIndex === i ? '3px solid var(--vc-gold)' : '3px solid transparent',
              }}
            >
              <button
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
                className="w-full flex items-center justify-between px-6 py-5 text-left"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                <span
                  className="text-sm sm:text-base font-medium pr-4 transition-colors duration-200"
                  style={{
                    color: openIndex === i ? 'var(--vc-fg)' : 'var(--vc-fg-muted)',
                  }}
                >
                  {item.q}
                </span>
                <span
                  className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-200"
                  style={{
                    backgroundColor: openIndex === i ? 'rgba(214,168,74,0.15)' : 'rgba(255,255,255,0.06)',
                    border: `1px solid ${openIndex === i ? 'rgba(214,168,74,0.35)' : 'rgba(255,255,255,0.1)'}`,
                  }}
                >
                  <Plus
                    className="w-4 h-4 transition-transform duration-200"
                    style={{
                      color: 'var(--vc-gold)',
                      transform: openIndex === i ? 'rotate(45deg)' : 'rotate(0deg)',
                    }}
                  />
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{
                  maxHeight: openIndex === i ? '500px' : '0px',
                  opacity: openIndex === i ? 1 : 0,
                }}
              >
                <div className="px-6 pb-5">
                  <p
                    className="text-sm leading-relaxed max-w-2xl"
                    style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
                  >
                    {item.a}
                  </p>
                  {item.bulletIntro && (
                    <p
                      className="text-sm leading-relaxed mt-4 max-w-2xl"
                      style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
                    >
                      {item.bulletIntro}
                    </p>
                  )}
                  {item.bullets && (
                    <ul className="mt-3 space-y-2 max-w-2xl">
                      {item.bullets.map((bullet, bi) => (
                        <li
                          key={bi}
                          className="flex items-start gap-3 text-sm leading-relaxed"
                          style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
                        >
                          <span
                            className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0"
                            style={{ backgroundColor: 'var(--vc-gold)' }}
                          />
                          {bullet}
                        </li>
                      ))}
                    </ul>
                  )}
                  {item.bulletOutro && (
                    <p
                      className="text-sm leading-relaxed mt-4 max-w-2xl"
                      style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
                    >
                      {item.bulletOutro}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
